import { createNoLoadActionTypes /* , createActionTypes */ } from './utils';

export const SET_TOURS_DETAILS = createNoLoadActionTypes('SET_TOURS_DETAILS');
export const RESET_BASIC_TOURS = createNoLoadActionTypes('RESET_BASIC_TOURS');
export const RESET_TOURS = createNoLoadActionTypes('RESET_TOURS');
export const GET_TOURS_CONFIGURATIONS = createNoLoadActionTypes('GET_TOURS_CONFIGURATIONS');
export const SUBMIT_TOURS_CONFIGURATIONS = createNoLoadActionTypes('SUBMIT_TOURS_CONFIGURATIONS');
